export default "/_next/static/chunks/fonts/pxiByp8kv8JHgFVrLCz7Z11lFc-K-04bc8605e1b51dbf9068626afa361f36.woff2";